import * as moment from 'moment';
import * as React from 'react';
import { url } from 'src';
import { CardEvent } from 'src/store/events/types';
import { User } from 'src/store/user/types';
import './EventDetailPrint.scss';

interface Props {
  user: User;
  event: CardEvent;
  onPrintDone: () => void;
  renderInfo: (event: CardEvent) => {};
}

export default class EventDetailPrint extends React.Component<Props> {
  render() {
    const { user, event, renderInfo } = this.props;
    return (
      <React.Fragment>
        <div className="border bottom" style={{ marginBottom: '20px', paddingBottom: '10px' }}>
          {user.image && user.image.url ? (
            <div className="clearfix">
              <img
                height="50px"
                width="auto"
                style={{ float: 'left' }}
                className="clearfix"
                src={url + user.image.url}
              />
            </div>
          ) : (
            <div className="clearfix ">
              <h1
                id="eventDetailPrintUserName"
                style={{
                  fontWeight: 400,
                  fontSize: '26pt',
                  width: '80%',
                  display: 'inline-block',
                  textAlign: 'left',
                  float: 'left',
                  margin: 0,
                  lineHeight: 1,
                  padding: 0
                }}
              >
                {user.name}
              </h1>
            </div>
          )}
        </div>
        <div className="clearfix" style={{ position: 'relative', minHeight: '150px' }}>
          {event.image && event.image.url && (
            <img
              onLoad={() => {
                window.print();
              }}
              width="50%"
              height="auto"
              style={{ objectFit: 'cover', float: 'left' }}
              src={url + event.image.url}
            />
          )}
        </div>
        <div className="border bottom" style={{ marginBottom: '5px', paddingBottom: '5px' }}>
          <span
            id="eventDetailPrintDate"
            style={{
              color: '#000',
              fontWeight: 700,
              textAlign: 'left',
              fontSize: '14pt',
              display: 'block',
              lineHeight: '1',
              margin: '10px 0 5px 0'
            }}
          >
            {moment(event.begins).format('dddd')}
          </span>
          <h1
            id="eventDetailPrintHeader"
            style={{ margin: '0', fontWeight: 700, textAlign: 'left', fontSize: '24pt' }}
          >
            {event.title}
          </h1>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 noPad">{renderInfo(event)}</div>
            <div
              className="col-6 noPad"
              id="eventDetailPrintDescription"
              style={{
                textAlign: 'left',
                fontSize: '8pt',
                paddingLeft: '20px',
                boxSizing: 'border-box'
              }}
            >
              {event.description.split(/<br \/>|[\n]+/).map((item: string, key: number) => {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Event/EventDetailPrint/EventDetailPrint.tsx